import { useNavigate } from 'react-router-dom';
import { AuthService } from 'src/services/AuthService/AuthService';

import { useUserBasic } from '@utils/hooks/useUserBasic';
import { useUserSession } from '@utils/hooks/useUserSession';

import { getPath } from '@services/RouteService/paths';

import { authVar } from '@boot/reactiveVariables';

/**
 * Single-use hook (only in AppLateInit.tsx).
 */
export const useCheckIsLoggedIn = () => {
    const [getSessionUser] = useUserSession({
        context: { logoutOnError: true },
    });
    const { data } = useUserBasic();
    const navigate = useNavigate();

    const checkIsLoggedIn = async () => {
        const sessionToken = AuthService.getSessionToken();
        const metadata = AuthService.getMfaMetadata();

        try {
            if (sessionToken && metadata) {
                authVar({ ...authVar(), isMfa: true });
                navigate(
                    metadata.requireSetup
                        ? getPath({ path: '/auth/setup-mfa' })
                        : getPath({ path: '/auth/enter-code' }),
                );
            } else if (!sessionToken) {
                await AuthService.logout(false, { keepTenantData: true });
            } else {
                await getSessionUser();
            }
        } catch (error) {
            console.error('checkIsLoggedIn ::', error);
        }
    };

    return {
        checkIsLoggedIn,
        userData: data?.user,
    };
};
